import { create } from "zustand";

export interface Condition {
	id?: string;
	ruleSetId?: string;
	operator: string;
	operand: string;
	value: string;
}

export interface Action {
	id?: string;
	ruleSetId?: string;
	flowId: string;
}

export interface RuleSet {
	id: string;
	ruleId?: string;
	order: number;
	conditions: Condition[];
	actions: Action[];
}

interface flowType {
	id: string;
	name: string;
}

interface flowAction {
	id: string;
	name: string;
}

export interface IRule {
	id?: string;
	brandId?: string;
	environmentId?: string;
	flowTypeId?: string;
	flowActionId?: string;
	flowType?: flowType;
	flowAction?: flowAction;
	status?: string;
	ruleset: RuleSet[];
}

export interface FlowOption {
	id: string;
	name: string;
}

export interface RuleToDelete {
	id: string;
	name: string;
}

export interface RuleState {
	isLoading: boolean;
	error: string | null;
	showCreateRule: boolean;
	showDropdown: boolean;
	toggleRuleStatus: string | null;
	isDeleteModalOpen: boolean;
	ruleToDelete: RuleToDelete | null;
	isEditModalOpen: boolean;
	selectedRuleId: string | null;
	setShowCreateRule: (show: boolean) => void;
	setShowDropdown: (show: boolean) => void;
	setToggleRuleStatus: (id: string | null) => void;
	setLoading: (isLoading: boolean) => void;
	setError: (error: string | null) => void;
	openDeleteModal: (id: string, name: string) => void;
	closeDeleteModal: () => void;
	openEditModal: (id: string) => void;
	closeEditModal: () => void;
}

export const useRuleStore = create<RuleState>((set) => ({
	isLoading: false,
	error: null,
	showCreateRule: false,
	showDropdown: false,
	toggleRuleStatus: null,
	isDeleteModalOpen: false,
	ruleToDelete: null,
	isEditModalOpen: false,
	selectedRuleId: null,
	setShowCreateRule: (show) => set({ showCreateRule: show }),
	setShowDropdown: (show) => set({ showDropdown: show }),
	setToggleRuleStatus: (id) => set({ toggleRuleStatus: id }),
	setLoading: (isLoading) => set({ isLoading }),
	setError: (error) => set({ error }),
	openDeleteModal: (id, name) =>
		set({
			isDeleteModalOpen: true,
			ruleToDelete: { id, name }
		}),

	closeDeleteModal: () =>
		set({
			isDeleteModalOpen: false,
			ruleToDelete: null
		}),
	openEditModal: (id) =>
		set({
			isEditModalOpen: true,
			selectedRuleId: id
		}),
	closeEditModal: () =>
		set({
			isEditModalOpen: false,
			selectedRuleId: null
		})
}));
